import { useState } from 'react';
import { XiaoShao } from './XiaoShao';

export function LoginCompanion({ word, passwordFocused, busy, hasError }: {
  word: string; passwordFocused: boolean; busy: boolean; hasError: boolean;
}) {
  const [reaction, setReaction] = useState(0);
  const message = busy ? '正在確認登入，稍候就好。' : hasError ? '請確認下方提示，我在這裡等你。'
    : passwordFocused ? '慢慢輸入，我先閉上眼睛。' : reaction ? '你好，我是小哨。登入後一起看看現場。'
      : `${word}，歡迎回來。請用平台帳號登入。`;
  return <>
    <div className="flex items-center justify-between gap-2">
      <h2 className="mt-2.5 font-display text-[23px] font-bold tracking-tight sm:text-[26px]">登入觀測平台</h2>
      <button type="button" className="companion-login-pet" aria-label="跟小哨打招呼" disabled={busy}
        onClick={() => setReaction((value) => value + 1)}>
        <XiaoShao expression={passwordFocused ? 'blink' : hasError ? 'notice' : busy ? 'left' : undefined} reaction={reaction} />
      </button>
    </div>
    <p className="min-h-[40px] text-[13px] leading-5 text-muted-foreground" role="status">{message}</p>
  </>;
}
